import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Row, Col, Tooltip, Radio, Button, Icon, message } from 'antd';
import { connect } from 'react-redux';
import withInquiryMasterData from '../hoc/InitInquiryMaster';
import * as  moment from 'moment';
import { fetchAllBidsForBooking } from 'src/api/booking';
import PricePerContainer from '../../../common/PricePerContainer';
import PriceTotal from '../../../common/PriceTotal';
import TaxWarning from '../../../common/TaxWarning';
import { BID_ROUTES_CARD_LABELS, getDomesticCharges, getUnitByMode } from '../InquiryUtils';
import { commonStyles } from 'src/Library/CommonStyles';
import { isValidArray, getDateValue } from 'src/Library/Helper';
import { InquiryModes } from 'src/Library/Constants';
import isEmpty from 'lodash/isEmpty';
import { tokens } from 'src/design-system';

const styles = theme => ({
  modal: {
    border: '1px solid #E8E8E8',
    borderRadius: `${tokens.radius.md}px`,
    paddingBottom: '0px',
    marginBottom: '10px',
    minWidth: '1200px',
  },
  body: {
    marginTop: '30px',
    marginBottom: '30px',
    padding: '24px 24px 24px 24px',
    height: '100%',
  },
  title: {
    fontSize: `${tokens.fontSize.h3}px`,
    fontWeight: 'bold',
  },
  tableRow: {
    fontSize: `${tokens.fontSize.body}px`,
    color: '#262626',
    fontWeight: tokens.fontWeight.semibold,
  },
  cardContainer: {
    height: '140px',
    marginTop: '8px',
    padding: '16px 16px 13px 16px',
    backgroundColor: tokens.colors.bgWhite,
    border: '1px solid #D9D9D9',
    borderRadius: `${tokens.radius.md}px`,
    '& .ant-radio-wrapper': {
      float: 'left',
      paddingTop: '4px',
    },
    '& .ant-radio': {
      float: 'left',
    },
  },
  cardHeaderItemsStyle: {
    fontSize: '11px',
    marginBottom: '10px',
    color: '#595959',
  },
  info: {
    fontSize: '13px',
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    float: 'right',
    width: '44%',
    padding: '0px 0px 0px 5px',
    lineHeight: '100%',
  },
  dateStyle: {
    fontSize: '13px',
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    float: 'right',
    width: '56%',
    padding: '0px 0px 0px 5px',
    lineHeight: '100%',
  },
  rankOneTag: {
    backgroundColor: '#DFDDFF',
    borderRadius: `${tokens.radius.md}px`,
    border: '1px solid #4A3CE4',
    width: '68px',
    padding: '2px 8px',
    minHeight: '20px',
    margin: '16px 0px 0px',
  },
  rankTag: {
    fontSize: `${tokens.fontSize.h3}px`,
    color: '#262626',
    margin: '16px 0px 0px',
  },
  confirmedDiv: {
    borderRadius: `${tokens.radius.md}px`,
    color: tokens.colors.bgWhite,
    fontSize: `${tokens.fontSize.small}px`,
    textAlign: 'center',
    width: '100px',
    backgroundColor: '#52C41A',
    border: '1px solid #389E0D',
  },
  ffName: {
    fontSize: `${tokens.fontSize.body}px`,
    color: '#262626',
    ...commonStyles(theme).ellipses,
    maxWidth: '220px',
  },
  domesticInfo: {
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    padding: '0px 0px 0px 5px',
  },
});

const COLORS = {
  GREEN: '#52C41A',
};

class ViewBidRanking extends React.PureComponent<any, any> {
  state: any = {
    confirmingBid: false,
    selectedBid: this.props.bidRanking && this.props.bidRanking.data[0],
    isLoading: true,
  };

  async componentDidMount() {
    if (!this.props.booking) {
      this.fetchAllBidsForBooking();
    }
    if (this.props.confirmedBidId && this.props.confirmedBidId.length) {
      const tempArr = this.props.bidRanking.data.filter(
        el => el.id === this.props.confirmedBidId)[0];
      this.setState({
        selectedBid : tempArr,
      });
    }
  }

  fetchAllBidsForBooking = async () => {
    const { bookingId } = this.props;
    const bidRankingApiData = {
      bookingId,
      rankingCriteria: 'RANK_WITHOUT_TAX',
      bookingOrigin: 'INQUIRY',
    };
    const response = await fetchAllBidsForBooking(bidRankingApiData);
    if (response.isSuccess) {
      this.setState({
        isLoading: false,
        bidRankingData: response.data,
      });
    } else {
      message.error(response.errorMessage);
    }
  }

  createBooking = async() => {
    this.setState({ confirmingBid: true });
    await this.props.createBooking(this.state.selectedBid.id);
    this.setState({ confirmingBid: false });
  }

  renderCol1 = (bidData) => {
    const { classes } = this.props;
    return (
      <Col span={6} style={{ paddingLeft: '10px' }}>
        <Tooltip title={bidData.ffName} placement="topLeft">
          <div className={classes.ffName}>{bidData.ffName}</div>
        </Tooltip>
        <div style={{ marginTop: '8px' }}>
          <Tooltip title={bidData.ffCarrierName}>
            <img src={bidData.carrierLogoUrl} style={{ maxHeight: '40px', maxWidth: '70%'}}/>
          </Tooltip>
        </div>
        <div className={ bidData.rank === 1 ? classes.rankOneTag : classes.rankTag }>
          {bidData.rank && `Rank: ${bidData.rank}`}</div>
      </Col>
    );
  }

  renderCol2 = (bidData) => {
    const { classes, mode, currency } = this.props;
    if (!bidData || !bidData.otherDetails) return '';
    const { otherDetails } = bidData;
    const roadModes = [InquiryModes.DOMESTIC, InquiryModes.RPTL];
    const disableCombinedFreeDays = !(mode === InquiryModes.TRAILER || mode === InquiryModes.LCL);
    const enableFreeDays = !(mode === InquiryModes.LCL || roadModes.includes(mode));
    if (roadModes.includes(mode)) {
      return this.renderDomesticCol2(bidData, classes, currency);
    }
    return (
      <Col span={6}>
        <div>
          {enableFreeDays && (<>
            {mode !== InquiryModes.TRAILER &&
            <div className={classes.cardHeaderItemsStyle}>Demurrage Free Days
              <span className={classes.info}>{otherDetails?.demurrageFreeDays ?? '-'}</span>
            </div>}
            <div className={classes.cardHeaderItemsStyle}>Detention Free Days
              <span className={classes.info}>{otherDetails?.detentionFreeDays ?? '-'}</span>
            </div>
            {disableCombinedFreeDays && (
              <div className={classes.cardHeaderItemsStyle}>
                Combined Free Days
                <span className={classes.info}>{otherDetails?.combinedFreeDays ?? '-'}</span>
              </div>
            )}
            {mode === InquiryModes.TRAILER &&
            <div className={classes.cardHeaderItemsStyle}>Detention Cost Per Day
              <span className={classes.info}>{!isEmpty(otherDetails?.detentionCostPerDay) ?
              `${currency[`${otherDetails?.detentionCostPerDay?.currency}`]}${otherDetails?.detentionCostPerDay?.amount}`
              : '-'}</span>
            </div>}
          </>)}
          {mode !== InquiryModes.TRAILER && <div className={classes.cardHeaderItemsStyle}>Transit Days
            <span className={classes.info}>{otherDetails?.transitDays ?? '-'}</span>
          </div>}
        </div>
      </Col>
    );
  }

  renderCol3 = (bidData) => {
    const { classes, mode } = this.props;
    const { otherDetails } = bidData;
    const enableRoute = mode !== InquiryModes.DOMESTIC && mode !== InquiryModes.RPTL;
    return (
      <Col span={6}>
        <div>
        {
          mode === InquiryModes.TRAILER ?
            <div className={classes.cardHeaderItemsStyle}>Round Trip Time
              <span className={classes.dateStyle}>
                {!isEmpty(otherDetails?.roundTripTime) ?
                  `${otherDetails?.roundTripTime?.value} ${otherDetails?.roundTripTime?.type}`
                  : '-'}</span>
            </div> :
          <React.Fragment>
            <div className={classes.cardHeaderItemsStyle}>Schedule
              <span className={classes.dateStyle}>
                {bidData && bidData.otherDetails &&
                  bidData.otherDetails.schedule && bidData.otherDetails.schedule.length > 0 ?
                  bidData.otherDetails.schedule.map(item => `${item[0].toUpperCase()} `)
                  : '-'}
              </span>
            </div>
            {bidData?.otherDetails?.etd && <div className={classes.cardHeaderItemsStyle}>
              ETD <Tooltip title={
                    mode === InquiryModes.AIRCARGO ? 'Flight Date' 
                    : (mode === InquiryModes.DOMESTIC || mode === InquiryModes.RPTL ? 'Departure Date' 
                    :'Sailing Date')
                    }>
                <Icon type="exclamation-circle" theme="filled" />
                </Tooltip>
              <span className={classes.dateStyle}>
                {getDateValue(bidData?.otherDetails?.etd)?.format('DD MMM YYYY') || '-'}
              </span>
            </div>}
          </React.Fragment>}
          <div className={classes.cardHeaderItemsStyle}>Valid Till
            <span className={classes.dateStyle}>
              {bidData && bidData.validTill ?
                moment(bidData.validTill).format('DD MMM YYYY') : '-'}</span>
          </div>
          {enableRoute ? <div className={classes.cardHeaderItemsStyle}>
            Route
            <span className={classes.dateStyle}>
              {otherDetails.route?.map(item => BID_ROUTES_CARD_LABELS[item] || item).join(', ') || '-'}
            </span>
          </div> : null}
          {otherDetails.transshipmentVia && <div className={classes.cardHeaderItemsStyle}>Transshipment
            <Tooltip title={otherDetails.transshipmentVia?.length > 1 ?
                otherDetails.transshipmentVia.map(item =>
                  <div>{item.label}</div>) : ''}>
              <span className={classes.dateStyle}>
                {(isValidArray(otherDetails.transshipmentVia) ?
                  otherDetails.transshipmentVia[0].label : '-')}
                {otherDetails.transshipmentVia?.length <= 1 ? ''
                  : ` +${otherDetails.transshipmentVia &&
                  otherDetails.transshipmentVia.length - 1}`}
              </span>
            </Tooltip>
          </div>}
        </div>
      </Col>
    );
  }

  renderCol4 = (bidData) => {
    const { classes, mode } = this.props;
    const enablePricePerContainer = mode !== InquiryModes.DOMESTIC && mode !== InquiryModes.RPTL;
    return (
      <Col span={5}>
        <div style={{ margin: '0px 15px' }}>
          {bidData.isConfirmed ?
            <div className={classes.confirmedDiv}>
              Confirmed Bid
              </div>
            :
            <div style={{ fontSize: `${tokens.fontSize.caption}px` }}>
              {bidData.bidStatus}
            </div>}
          {enablePricePerContainer ? <span style={{ fontSize: 14 }} >Price &nbsp;&nbsp;</span> : <div style={{height: '10px'}}/>}
          {enablePricePerContainer ? <PricePerContainer
            mode={mode}
            amount={bidData.totalPerUnit && bidData.totalPerUnit.amount}
            currency={bidData.totalPerUnit && bidData.totalPerUnit.currency}
            freightPerUnit={bidData.freightPerUnit}
            containerTypes={bidData.totalPerUnitType}
            sourceObjectType={'BID'} /> : null}
          <div style={{ display: 'flex', alignItems: 'center' }}>
          <PriceTotal
            amount={bidData.shipperTotalWithoutTax.amount}
            currencySymbol={this.props.currency[`${bidData.shipperTotalWithoutTax.currency}`]}/>
          </div>
        </div>
      </Col>
    );
  }

  renderDomesticCol2 = (bidData, classes, currency) => {
    const { chargeDetails, otherDetails } = bidData;
    const { freightCharges, originCharges, destinationCharges } = chargeDetails;
    const isExchangeDatePresent = bidData?.exchangeRateDate;
    const currencySymbol = this.props.currency[`${bidData?.userTotalWithoutTax?.currency}`]
    return (
      <Col span={6}>
        <Row>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Transport Charges
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {getDomesticCharges(freightCharges, isExchangeDatePresent, currencySymbol)}
          </Col>
        </Row>
        <Row>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Origin Charges
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {getDomesticCharges(originCharges, isExchangeDatePresent, currencySymbol)}
          </Col>
        </Row>
        <Row>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Destination Charges
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {getDomesticCharges(destinationCharges, isExchangeDatePresent, currencySymbol)}
          </Col>
        </Row>
        <Row>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Transit Days
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {otherDetails?.transitDays}
          </Col>
        </Row>
      </Col>
    );
  }

  renderFooter = () => {
    const { selectedBid } = this.state;

    return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <a style={{ color: tokens.colors.primary, fontSize: `${tokens.fontSize.h3}px` }}
        onClick={this.props.handleCancel}>Previous</a>
      <Button
        loading={this.state.confirmingBid}
        type="primary"
        style={{ backgroundColor: tokens.colors.primary, border: tokens.colors.primary }}
        onClick={selectedBid.rank === 1 || (selectedBid.reasonForNonL1BidConfirmation)  ? 
          this.createBooking : () => {
          this.props.openInformReason(this.state.selectedBid,
            this.props.bidRanking.data.find(bid => bid.rank === 1));
        }}>Next
      </Button>
    </div>;
  }

  onChangeBid = (e) => {
    this.setState({
      selectedBid: e.target.value,
    });
  }

  onCardRowClick = (item) => {
    this.setState({
      selectedBid : item,
    });
  }

  render() {
    const { classes, handleCancel, visible, bidRanking, mode } = this.props;
    const { selectedBid, bidRankingData } = this.state;
    return <Modal className={classes.modal}
      closable
      // header={<div>sdfad</div>}
      footer={this.props.booking ? this.renderFooter() : false}
      width="1200px"
      title={<div style={{ fontWeight: 800 }}>
        {this.props.heading || 'Select Bid'}</div>}
      visible={visible}
      onCancel={() => handleCancel()}
    >
      <TaxWarning
        unit={getUnitByMode(mode)}
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'flex-end',
        }} />
    { bidRanking &&
      <>
        {bidRanking.data.filter(bid => bid.isConfirmed === true).map(bid => (
          <div style={
            ((selectedBid.id === bid.id) ?
              { border: `1px solid ${COLORS.GREEN}` } : undefined)}
              className={classes.cardContainer}>
              <Radio.Group onChange={this.onChangeBid} value={selectedBid}
              style={{ width: '100%' }}>
                <Row style={{ cursor: 'pointer' }} onClick={() => this.onCardRowClick(bid)}>
                  <Radio key={bid.id} value={bid}></Radio>
                  {this.renderCol1(bid)}
                  {this.renderCol2(bid)}
                  {this.renderCol3(bid)}
                  {this.renderCol4(bid)}
                </Row>
              </Radio.Group>
          </div>
        ))}
      </>
    }
    </Modal>;
  }
}
const mapStateToProps = ({ masterData }, ownProps) => ({
  currency: masterData.currencySymbols,
});
export default withInquiryMasterData(injectSheet(styles)(connect(mapStateToProps,
  null)(ViewBidRanking)));
